import { connect } from "react-redux";
import SurveyStepActionsKpi from "./SurveyStepActionsKpi";
//import { surveySelector } from "./../../../../redux/selectors";
import { addStepSurvey } from "./../../../../redux/actions/surveyActions";
import getKpiList from "./../../../../redux/actions/surveyActions";
import LocationType from "./LocationType";
import { surveyUpdateLocationTypes } from "./../../../../redux/actions/surveyActions";
import { gotoLocationType } from "./../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
  //TODO selectors/reducers
  const locations = state.survey.surveyManager.surveyProgress.locationTypes || [];
  const allLocations = state.survey.surveyManager.surveyProgress.locations || [];
  let nbLocationsCompleted = 0;
  //each location must have more than 1  kpi selected
  for (let i = 0; i < locations.length; i++) {
    const location = locations[i];
    const locationType = new LocationType(location);

    //add one location completed id kpi selected > 0
    nbLocationsCompleted += locationType.nbKpiSelected() > 0 ? 1 : 0;
  }

  let nextDisabled = locations.length === 0 || nbLocationsCompleted < allLocations.length;

  return {
    //currentSurvey: surveySelector(state, ownProps),
    locations: state.survey.surveyManager.surveyProgress.locations || [],
    surveyProgressModel: state.survey.surveyManager.surveyProgress.model[0] || {},
    nextDisabled: nextDisabled
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addStepSurvey: survey => {
      dispatch(addStepSurvey(survey));
    },
    surveyUpdateLocationTypes: locationTypes => {
      dispatch(surveyUpdateLocationTypes("set", locationTypes));
    },
    getKpiList: () => {
      dispatch(getKpiList());
    },
    gotoLocationType: (ltN = 0) => {
      dispatch(gotoLocationType(ltN));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyStepActionsKpi);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiContainer.js